import React from "react";
import { Row } from "reactstrap";
import { ColValue } from "../ProductionModule/index";
import { ColPrompt } from "./index";
// Used by the DP5, Duro, Heli KV2008B, Heli KV2019B, M50, Mahan Dryer,
// Mahan Oven, Saurer TC2, SSM Kingspool, UT50/60, Xeno, and Xorella machines

export default function RadioButtonRow({ promptRowSizeProp, valueRowSizeProp, titleProp, descriptionProp = "", children }) {

   return (
      <Row className="mb-2">
         <ColPrompt title={titleProp} bold={true} description={descriptionProp} sizeProp={promptRowSizeProp} />
         <ColValue size={valueRowSizeProp}>
            {children}
         </ColValue>
      </Row>
   );
}
